<app-tips
  matIcon="auto_awesome"
  bgColor="var(--mat-sys-primary-container)"
  txtColor="var(--mat-sys-on-primary-container)"
  matIconColor="var(--mat-sys-on-primary-container)"
>
  <div class="banner-head">
    <span class="banner-pill">Nouveauté</span>
    <span class="banner-title">{{ announcement().title }}</span>
    <span class="banner-meta">{{ meta() }}</span>
  </div>
  <div class="banner-body" [innerHTML]="announcement().content | anomalyMarkdown"></div>
  @if (actions()) {
    @if (tourHref(); as href) {
      <a mat-flat-button class="discover" [href]="href" target="_blank" rel="noopener">
        <svg lucideCompass></svg>
        Découvrir
      </a>
    }
    <div class="banner-actions">
      <button
        mat-icon-button
        aria-label="Fermer le bandeau"
        matTooltip="Fermer"
        (click)="dismiss.emit()"
      >
        <svg lucideX></svg>
      </button>
    </div>
  } @else {
    <span mat-flat-button class="discover discover-preview" aria-hidden="true">
      <svg lucideCompass></svg>
      Découvrir
    </span>
  }
</app-tips>
